import { render, staticRenderFns } from "./Guide.vue?vue&type=template&id=c5ba703a&scoped=true&"
import script from "./Guide.vue?vue&type=script&lang=js&"
export * from "./Guide.vue?vue&type=script&lang=js&"
import style0 from "./Guide.vue?vue&type=style&index=0&id=c5ba703a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ba703a",
  null
  
)

export default component.exports